/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React from 'react';
import { IssueViewSkeleton } from '@jira/issue__issue-view-skeleton/src/IssueViewSkeleton.tsx';
import { Redirect, useResource } from '@atlassian/react-resource-router';
import { QuickSearchToGlobalIssueNavigatorRedirect } from './jira-global-issue-navigator-redirect/index.tsx';
import { jiraSearchResource } from './resources/index.tsx';
/**
 * Handles redirection to the appropriate Jira search results page. It provides a loading state for user feedback during data fetching, offers a fallback for errors, and ensures a seamless user experience by redirecting based on the search outcome.
 */
export const JiraSearchRedirect = (): React.JSX.Element => {
	const { data, loading, error } = useResource(jiraSearchResource);
	if (loading) {
		return <IssueViewSkeleton />;
	}
	if (error || !data?.url) {
		// handle api error state
		return <QuickSearchToGlobalIssueNavigatorRedirect />;
	}
	return <Redirect to={data.url} push={false} />;
};
